import { Validator } from 'vee-validate';
import emailTel from './../customValidations/emailTel';
import emailNumber from './../customValidations/emailNumber';
import checkThai from './../customValidations/checkThai';
import checkEnglish from './../customValidations/checkEnglish';
import checkUpperCaseAndNumber from './../customValidations/checkUpperCaseAndNumber';
import emailUserId from './../customValidations/emailUserId';
import numberWithInfinity from './../customValidations/numberWithInfinity';

Validator.extend('emailTel', {
  getMessage: () => 'Please enter a valid E-mail Address or Phone number',
  validate: (value) => emailTel(value),
});

Validator.extend('emailNumber', {
  getMessage: () => 'Please enter a valid E-mail Address or Support Pin',
  validate: (value) => emailNumber(value),
});

Validator.extend('emailUserId', {
  getMessage: () => 'Please enter a valid E-mail Address or User Id',
  validate: (value) => emailUserId(value),
});

Validator.extend('checkUpperCaseAndNumber', {
  getMessage: () => 'Code must include A-Z and 0-9',
  validate: (value) => checkUpperCaseAndNumber(value),
});

Validator.extend('thaiOnly', {
  getMessage: () => 'Please enter Thai only',
  validate: (value) => checkThai(value),
});

Validator.extend('englishOnly', {
  getMessage: () => 'Please enter English only',
  validate: (value) => checkEnglish(value),
});

Validator.extend('englishOnly', {
  getMessage: () => 'Please enter English only',
  validate: (value) => checkEnglish(value),
});

Validator.extend('discountByPercent', {
  getMessage: (field) => `The ${field} field must be between 1,15 and 100.`,
  validate: (value) => value == 100 || (value >= 1 && value <= 15),
});

Validator.extend('numberWithInfinity', {
  getMessage: (field) => `The ${field} field must be between -1 or Numeral.`,
  validate: (value) => numberWithInfinity(value),
});

export default {
  $_veeValidate: {
    validator: 'new',
  },
  data: () => ({
    dictionary: {
      attributes: {},
      custom: {},
    },
  }),
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    resetFormError(formName, creds) {
      // console.log('reset form');
      if (formName) this.$validator.reset(formName);
      else this.$validator.reset();
      if (creds) creds.reset();
    },
  },
};
